var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconExternallink18 = function SvgAIconExternallink18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 6.99976V4H11",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9991 4L7.33301 10.6661",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0413 6.00005H4.66661C4.48982 6.00005 4.32026 6.07028 4.19525 6.19529C4.07023 6.32031 4 6.48986 4 6.66666V13.3328C4 13.5096 4.07023 13.6791 4.19525 13.8042C4.32026 13.9292 4.48982 13.9994 4.66661 13.9994H11.3327C11.5095 13.9994 11.6791 13.9292 11.8041 13.8042C11.9291 13.6791 11.9994 13.5096 11.9994 13.3328V9.9581",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconExternallink18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMy45OTk4IDYuOTk5NzZWNEgxMSIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTEzLjk5OTEgNEw3LjMzMzAxIDEwLjY2NjEiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik04LjA0MTMgNi4wMDAwNUg0LjY2NjYxQzQuNDg5ODIgNi4wMDAwNSA0LjMyMDI2IDYuMDcwMjggNC4xOTUyNSA2LjE5NTI5QzQuMDcwMjMgNi4zMjAzMSA0IDYuNDg5ODYgNCA2LjY2NjY2VjEzLjMzMjhDNCAxMy41MDk2IDQuMDcwMjMgMTMuNjc5MSA0LjE5NTI1IDEzLjgwNDJDNC4zMjAyNiAxMy45MjkyIDQuNDg5ODIgMTMuOTk5NCA0LjY2NjYxIDEzLjk5OTRIMTEuMzMyN0MxMS41MDk1IDEzLjk5OTQgMTEuNjc5MSAxMy45MjkyIDExLjgwNDEgMTMuODA0MkMxMS45MjkxIDEzLjY3OTEgMTEuOTk5NCAxMy41MDk2IDExLjk5OTQgMTMuMzMyOFY5Ljk1ODEiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";